import * as Sentry from '@sentry/react';
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { initAnalytics, track, Events } from './analytics';

initAnalytics();
track(Events.APP_LAUNCHED, {
  locale: (typeof window !== 'undefined' && window.__TG_HUNT_CONFIG__?.locale) || 'en',
});

Sentry.init({
  dsn: 'https://aRnE6hm7cxxNDApRvS78gHDL@s2603329.eu-central-1a.betterstackdata.com/2603329',
  environment: 'web',
});

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCE-YwUKevl-Gh5O6Ou5yRwVATaaYijbHo",
  authDomain: "tghunt-81aa8.firebaseapp.com",
  projectId: "tghunt-81aa8",
  storageBucket: "tghunt-81aa8.firebasestorage.app",
  messagingSenderId: "323831165630",
  appId: "1:323831165630:web:b808081bbbe62308fe64ef"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthProvider } from "./contexts/AuthContext";

const container = document.getElementById("app");
const root = createRoot(container)
root.render(
  <Sentry.ErrorBoundary>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Sentry.ErrorBoundary>
);